module.exports = __webpack_public_path__ + "37f2546fb4fd608a5120cfef8dbbf58b.svg";